import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function TeamSwitcher({ onTeamSwitch, teams: teamsProp, value, variant = 'header' }) {
  const { user, isAdmin, switchActiveTeam } = useAuth();
  const [switching, setSwitching] = useState(false);

  const teams = (Array.isArray(teamsProp) && teamsProp.length > 0)
    ? teamsProp
    : (user?.teams?.length ? user.teams : (user?.team ? [user.team] : []));

  if (!user || teams.length <= 1) {
    return null;
  }

  const current = value || user.team || teams[0];

  const handleChange = async (event) => {
    const nextTeam = event.target.value;
    if (!nextTeam || nextTeam === current || switching) return;

    setSwitching(true);
    const result = await switchActiveTeam(nextTeam);
    setSwitching(false);

    if (result.success) {
      onTeamSwitch?.(nextTeam);
    } else {
      alert(result.error || 'Failed to switch team');
    }
  };

  const isPage = variant === 'page';

  return (
    <div className="flex items-center gap-2">
      <label
        htmlFor={isPage ? 'team-switcher-page' : 'team-switcher'}
        className={`text-xs hidden sm:inline ${isPage ? 'text-gray-500' : 'text-white/80'}`}
      >
        {isAdmin() ? 'Viewing' : 'Team'}
      </label>
      <select
        id={isPage ? 'team-switcher-page' : 'team-switcher'}
        value={teams.includes(current) ? current : teams[0]}
        onChange={handleChange}
        disabled={switching}
        className={isPage
          ? 'text-sm rounded-lg px-2 py-1.5 bg-white text-gray-900 border border-gray-300 max-w-[140px] sm:max-w-[200px] truncate disabled:opacity-60'
          : 'text-sm rounded-lg px-2 py-1.5 bg-white/95 text-theme-primary border border-white/30 max-w-[140px] sm:max-w-[200px] truncate disabled:opacity-60'}
        aria-label="Switch active team"
      >
        {teams.map((team) => (
          <option key={team} value={team}>
            {team}
          </option>
        ))}
      </select>
    </div>
  );
}
